import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { requestParentScrollToTop } from "../helper/embedViewport";

// Opening another page (e.g. a property from the list) starts at its top.
// Going back keeps the browser's position, and query changes do not scroll.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current === pathname) {
      return;
    }
    previousPathname.current = pathname;
    if (history.action !== "POP") {
      window.scrollTo(0, 0);
      // Embedded at full height, only the page around the iframe can scroll.
      requestParentScrollToTop();
    }
  }, [pathname, history]);

  return null;
};

export default ScrollToTop;
